import React, { useState } from 'react';
import { FileCheck, Loader } from 'lucide-react';
import { aiAPI } from '../services/api';
import toast from 'react-hot-toast';
import MarkdownRenderer from './MarkdownRenderer';
import StatsAndTabs from './StatsAndTabs';

const CaseSummary = ({ onSuccess, stats, loading: statsLoading }) => {
  const [caseDetails, setCaseDetails] = useState('');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!caseDetails.trim()) {
      toast.error('Please enter case details');
      return;
    }

    setLoading(true);
    setResult('');

    try {
      const response = await aiAPI.summarizeCase({ caseDetails });

      setResult(response.result);
      toast.success('Case summary completed!');
      
      if (onSuccess) {
        onSuccess();
      }
    } catch (error) {
      console.error('Case summary failed:', error);
      toast.error('Failed to summarize case');
    } finally {
      setLoading(false);
    }
  };

  const handleClear = () => {
    setCaseDetails('');
    setResult('');
  };

  return (
    <div>
      <div className="content-header">
        <div className="welcome-section">
          <h2>Case Summary</h2>
          <p>Generate comprehensive case summaries with AI analysis</p>
        </div>
      </div>

      <StatsAndTabs stats={stats} loading={statsLoading} />

      <div className="tool-content">
        <div className="tool-header">
          <FileCheck size={24} />
          <h3>Case Summary</h3>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Case Details</label>
            <textarea
              className="form-textarea"
              placeholder="Enter case details, facts, issues, and any relevant information..."
              value={caseDetails}
              onChange={(e) => setCaseDetails(e.target.value)}
              disabled={loading}
              style={{ minHeight: '200px' }}
            />
          </div>

          <div style={{ display: 'flex', gap: '12px' }}>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={loading}
            >
              {loading ? (
                <>
                  <Loader size={16} className="animate-spin" />
                  Generating Summary...
                </>
              ) : (
                <>
                  <FileCheck size={16} />
                  Generate Summary
                </>
              )}
            </button>

            <button
              type="button"
              className="btn btn-secondary"
              onClick={handleClear}
              disabled={loading}
            >
              Clear
            </button>
          </div>
        </form>
      </div>

      {result && (
        <div className="tool-content">
          <div className="tool-header">
            <FileCheck size={24} />
            <h3>Case Summary</h3>
          </div>
          
          <MarkdownRenderer content={result} />

          <div style={{ marginTop: '16px' }}>
            <button
              className="btn btn-secondary"
              onClick={() => navigator.clipboard.writeText(result)}
            >
              Copy Summary
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default CaseSummary;
